import { AddressDto } from "../../../gateway/clients/bhac/bhac.dtos";
import { Country } from "../booking";
import { Address } from "./address.types";

export function getCountry() {
  const timezones = {
    "Australia/ACT": "AU",
    "Australia/Adelaide": "AU",
    "Australia/Brisbane": "AU",
    "Australia/Broken_Hill": "AU",
    "Australia/Canberra": "AU",
    "Australia/Currie": "AU",
    "Australia/Darwin": "AU",
    "Australia/Eucla": "AU",
    "Australia/Hobart": "AU",
    "Australia/LHI": "AU",
    "Australia/Lindeman": "AU",
    "Australia/Lord_Howe": "AU",
    "Australia/Melbourne": "AU",
    "Australia/NSW": "AU",
    "Australia/North": "AU",
    "Australia/Perth": "AU",
    "Australia/Queensland": "AU",
    "Australia/South": "AU",
    "Australia/Sydney": "AU",
    "Australia/Tasmania": "AU",
    "Australia/Victoria": "AU",
    "Australia/West": "AU",
    "Australia/Yancowinna": "AU",
    NZ: "NZ",
    "NZ-CHAT": "NZ",
    "Pacific/Chatham": "NZ",
    "Pacific/Auckland": "NZ"
  };

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (timezone === "" || !timezone) {
    return null;
  }

  return timezones[timezone];
}

export const TimeZoneBasedCountry = getCountry() || Country.NewZealand;
export const getDefaultAddress = (country?: string): Address => ({
  street1: "",
  city: "",
  postCode: "",
  suburb: "",
  addressState: "",
  country: country ?? TimeZoneBasedCountry
});

export const mapToAddress = ({
  street,
  city,
  suburb,
  postcode,
  addressState,
  country
}: AddressDto): Address => {
  return {
    street1: street,
    city: city ?? "",
    suburb,
    postCode: postcode,
    addressState: addressState ?? "",
    country
  };
};
